export default "https://assets.egbcdn.net/assets/packs/_/images/crypto-exchange/binance-30c37eb0451e753a1efdf150f8b4dc1f.png";